import { forwardRef } from 'react';
import type { SVGProps, Ref } from 'react';
type Props = SVGProps<SVGSVGElement>;
/**
 * @public
 */

const SvgStep2 = forwardRef((props: Props, svgRef: Ref<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width={32}
    height={32}
    fill="none"
    viewBox="0 0 32 32"
    ref={svgRef}
    {...props}
  >
    <circle cx={16} cy={16} r={15} stroke="#DFE1E6" strokeWidth={2} />
    <path
      fill="currentColor"
      d="M11.683 19.856l3.92-3.376c.363-.32.672-.597.928-.832.256-.245.464-.47.624-.672.16-.203.272-.4.336-.592a1.7 1.7 0 00.112-.624c0-.459-.128-.827-.384-1.104-.256-.288-.635-.432-1.136-.432-.576 0-1.03.16-1.36.48-.32.31-.48.848-.48 1.616h-2.4c0-1.27.357-2.272 1.072-3.008.725-.736 1.781-1.104 3.168-1.104.65 0 1.216.09 1.696.272a3.3 3.3 0 011.232.736c.33.31.576.683.736 1.12.17.437.256.912.256 1.424 0 .384-.07.752-.208 1.104a4.28 4.28 0 01-.576.992c-.235.32-.512.635-.832.944-.32.299-.661.597-1.024.896l-2.304 1.92h5.104V21.6h-8.48v-1.744z"
    />
  </svg>
));
SvgStep2.defaultProps = {
  'aria-hidden': true,
  focusable: 'false',
  role: 'img',
};
export default SvgStep2;
